var styles = {"modalMarginPreset":"Margin-module_modalMarginPreset__QJreg","defaultMarginPreset":"Margin-module_defaultMarginPreset__rtdIS","spaciousMarginPreset":"Margin-module_spaciousMarginPreset__WKGdM","narrowMarginPreset":"Margin-module_narrowMarginPreset__Qi5WG"};

export { styles as default };
//# sourceMappingURL=Margin.module.scss.js.map
